<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <flashable-background ref="labelInput">
                    <v-combobox
                        v-model="label"
                        ref="needFocus"
                        label="Label"
                        :items="labels"
                        auto-select-first
                    ></v-combobox>
                </flashable-background>
            </v-col>

            <v-col>
                <flashable-background ref="fieldInput">
                    <v-autocomplete
                        v-model="fieldId"
                        label="Bidang"
                        :items="fields"
                        :loading="fields.length === 0"
                    ></v-autocomplete>
                </flashable-background>
            </v-col>

            <v-col>
                <v-autocomplete
                    v-model="difficultyIndexId"
                    label="Indeks Kesulitan"
                    :items="difficultyIndexes"
                    :loading="fields.length === 0"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-file-input
            @change="imageChange"
            label="Gambar pertanyaan"
            prepend-icon="mdi-image"
            accept="image/*"
        ></v-file-input>

        <image-previewer :image="image"></image-previewer>

        <v-textarea
            v-model="question"
            label="Pertanyaan"
        ></v-textarea>

        <v-subheader>Jawaban</v-subheader>

        <answers-input></answers-input>

        <v-subheader>Pembahasan</v-subheader>

        <v-text-field
            v-model="explanationVideoUrl"
            label="Url video youtube"
        ></v-text-field>

        <video-previewer v-model="explanationVideoId" :url="explanationVideoUrl"></video-previewer>

        <v-file-input
            @change="explanationImagesChange"
            label="Pembahasan gambar"
            prepend-icon="mdi-image"
            multiple
            accept="image/*"
        ></v-file-input>

        <image-previewer @click="deleteImage" :image="explanationImages"></image-previewer>
    </v-form>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import AnswersInput from './AnswersInput'
import FlashableBackground from '@/components/FlashableBackground'
import imageCompression from 'browser-image-compression'
import ImagePreviewer from './ImagePreviewer'
import VideoPreviewer from './VideoPreviewer'

const ONE_MEGABYTE = 1048576

export default {
    components: {
        VideoPreviewer,
        AnswersInput,
        ImagePreviewer,
        FlashableBackground,
    },

    data: () => ({
        difficultyIndexes: [],
    }),

    computed: {
        ...sync('questionbank/input@*'),
        fields: sync('questionbank/fields'),
        labels: get('questionbank/labels'),
    },

    methods: {
        deleteImage(index) {
            this.isExplanationImagesChanged = true
            this.explanationImages.splice(index, 1)
        },

        focus() {
            this.$refs.needFocus.focus()
        },

        reset() {
            this.$refs.form.reset()
            this.$store.commit('questionbank/RESET_INPUT')
        },

        resetWithPreservedLabelAndField() {
            const label = this.label
            const fieldId = this.fieldId

            this.reset()

            this.$nextTick(() => {
                this.label = label
                this.fieldId = fieldId
            })
        },

        flash() {
            this.$refs.labelInput.flash()
            setTimeout(() => this.$refs.fieldInput.flash(), 300)
        },

        imageChange(image) {
            if (!! image && image.size > ONE_MEGABYTE) {
                imageCompression(image, {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 2000,
                    useWebWorker: false,
                })
                .then(compressed => {
                    compressed.fileName = image.name
                    compressed.lastModifiedDate = new Date()

                    this.image = compressed
                })
            } else {
                this.image = image
            }
        },

        explanationImagesChange(images) {
            this.isExplanationImagesChanged = true
            this.explanationImages = []

            if (!! images && images.length > 0) {
                images.forEach((image, idx) => {
                    if (image.size > ONE_MEGABYTE) {
                        imageCompression(image, {
                            maxSizeMB: 1,
                            maxWidthOrHeight: 2000,
                            useWebWorker: false,
                        })
                        .then(compressed => {
                            this.$set(this.explanationImages, idx, compressed)
                        })
                    } else {
                        this.$set(this.explanationImages, idx, image)
                    }
                })
            }
        }
    },

    created() {
        if (this.fields.length === 0) {
            this.$api.get('field/all')
                .then(response => {
                    this.fields = response.data.map(e => {
                        return {
                            text: e.title,
                            value: e.id
                        }
                    })
                })
        }

        if (this.difficultyIndexes.length === 0) {
            this.$apiv2.get('difficulty-index')
                .then(response => {
                    this.difficultyIndexes = response.data.difficultyIndex
                        .map(difficutlyIndex => ({
                            text: difficutlyIndex.title,
                            value: difficutlyIndex.id
                        }))
                })
        }
    },
}
</script>
